import { normalizePageParam } from "@/lib/helpers/parsers";
import { GET } from "@/lib/methods";
import {
  objectToQueryString,
  removeUndefinedProperties,
} from "@/lib/utilities";
import type { ApiPlatformResponseType } from "@/types/api-platform.type";
import type { DietCatalog } from "../types";
import type { DietsFiltersType } from "../types/dites-filtes.type";

export const getDiets = (
  filters: DietsFiltersType = {},
  requestOptions?: RequestInit,
) => {
  const parsedFilters = removeUndefinedProperties(filters);
  const queryString = objectToQueryString({
    ...parsedFilters,
    page: normalizePageParam(filters?.page),
  });

  return GET<ApiPlatformResponseType<DietCatalog>>({
    url: `${process.env.NEXT_PUBLIC_CATALOG_URL}/diets${queryString}`,
    params: {
      ...requestOptions,
      next: {
        tags: ["diets", queryString],
        revalidate: 3600,
        ...requestOptions?.next,
      },
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
};
